// Auth
export const ADD_FOO = "ADD_FOO"

